import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();
  return (
    <>
      <div className="Title">
        <h1 className="title-text">Hey, I'm Clearly</h1>
      </div>
      <h2 className="bio">
        I'm a Software Engineer who loves building things, learning new
        technologies, and solving complex problems. Check out some of my
        projects.
      </h2>
      <div className="duo-button">
        <h2 className="Projects-Button" onClick={() => navigate('/projects')}>Projects</h2>
        <h2 className="Projects-Button" onClick={() => navigate('/about')}>About</h2>
      </div>
    </>
  );
}

export default Home;
